export const baseUrl = 'https://testnet-rpc.elosys.io/api/v2'
